import { useState } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { ethers } from "ethers";
import { toast } from "react-toastify";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function VoteDlg(props) {
  const handleClose = () => {
    props.setOpen(false);
  };

  const handleCloseAddWallet = () => {
    if (!props.userAuthWallet) {
      toast.error("First connect the wallet!");
      return;
    }

    if (!votes) {
      toast.error("Please enter valid wallet address!");
      return;
    }

    const apiUrl = "/vote/add";
    Axios.post(process.env.REACT_APP_CRUD_SRV + apiUrl, {
      vaultId: props.dialogData.id,
      votes,
      auth: props.userAuthWallet,
      cs: sha256(
        apiUrl +
          props.dialogData.id +
          votes +
          props.userAuthWallet +
          process.env.REACT_APP_SECRET
      ).toString(),
    }).then((r) => {
      if (r.data?.status == 200) {
        console.log(votes + " votes has been added.");
        // props.getWallets();
      } else toast.error("Voting error. Please wait for some time and try again.");
    });

    props.setOpen(false);
  };

  const [votes, setVotes] = useState(40);

  function handleVotesChange(evt) {
    // console.log(evt.target.value);
    setVotes(evt.target.value);
  }

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open form dialog
      </Button> */}
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle>
          Vote to make the vault{" "}
          {props.dialogData?.id + " (" + props.dialogData?.vault}) automatic
          {/* <label className="vaultBadge">Auto</label> */}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            When a vault reaches 30 votes, our staff will check if it can be
            done so that the data from this vault are automatically collected
            (instead of manually added by you). If it is possible, then we will
            make this vault automatic. If it is not possible, then all votes for
            this vault will be returned to you.
          </DialogContentText>
          <DialogContentText>
            Voting uses DW tokens, which you receive as a gift when you top up
            your balance on DefiWatch.biz. 1 vote = 1 DW. You may place from{" "}
            <b>1 to {props.balanceDw}</b> votes.
            {/* <br />
            <small>
              E.g., when you top up your balance by $100, you will
              receive $100 and 100 DW. You may use $100 to track other people's
              wallets or your own wallet with the paid plans. DW are used to
              vote for the work you want to be done by us in the first place.
            </small> */}
          </DialogContentText>
          {/* <Button
            variant="outlined"
            className="extraSmall reqBtn"
            data-row={JSON.stringify({})}
            // onClick={handleClickOpen}
          >
            Add 1 Vote
          </Button> */}
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Votes to use"
            type="text"
            fullWidth
            variant="standard"
            onChange={handleVotesChange}
            value={votes}
          />

          {votes && (
            <DialogContentText>
              You are placing {votes} votes/30.
              {votes < 30 && (
                <span>
                  {" "}
                  After clicking the Vote button bellow, this vault will be
                  shown in "Pending request" section untill you or someone else
                  adds the missing {30 - votes} votes.
                </span>
              )}
              {votes > 30 && (
                <span>
                  {" "}
                  This vault will be processed before other vaults that get less
                  than {votes} votes.
                </span>
              )}
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleCloseAddWallet}>Vote</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
